import moment, { Moment } from 'moment';

export const ENROLL_DATE_FORMAT = 'MM/DD/YYYY';

export const toFormDate = (value: Moment | string | null | undefined): string => {
  if (moment.isMoment(value)) {
    return value.format(ENROLL_DATE_FORMAT);
  }
  return value ? String(value) : '';
};

export const parseFormDate = (value?: string | null): Moment =>
  moment(value || '', [ENROLL_DATE_FORMAT, moment.ISO_8601], true);

export const toApiDate = (value?: string | null): string => {
  const date = parseFormDate(value);
  return date.isValid() ? date.format('YYYY-MM-DD') : '';
};
